import React from 'react';
import { useSelector } from 'react-redux';
import InvoiceCard from './InvoiceCard';
import { selectLanguage } from '../../../../store/languageSlice';
import useFetchInvoicesByEpisode from '../../../../utilFunctions/completedAppointment/useFetchInvoicesByEpisode';
import CollapsibleWrapper from '../../CollapsibleWrapper';
import Loader from '../../../UI/Loader';

const Invoices = () => {
  const selectedHospital = useSelector(
    (state) => state.hospitalInfo.selectedHospital
  );
  const { data, loading, error } = useFetchInvoicesByEpisode();
  const { t, isRtl } = useSelector(selectLanguage);
  // console.log('prescription data', data);

  return (
    <CollapsibleWrapper title={t.Invoices}>
      <div className="flex flex-col">
        <ul>
          {data?.map((item, index) => {
            return (
              <li key={index} className="mb-2">
                <InvoiceCard index={index} item={item} showDownload={selectedHospital?.cr27InvoicePdfVisibility} />
              </li>
            );
          })}
        </ul>

        {loading && (
          <div className="w-full justify-center">
            <Loader roundLoader />
          </div>
        )}
        {!loading && data?.length === 0 && (
          <div className="w-full flex justify-center">
            <span className="mt-8">{t.NoRecord}</span>
          </div>
        )}
      </div>
    </CollapsibleWrapper>
  );
};

export default Invoices;
